import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/identity-and-access/roles/")({
  staticData: {
    title: "roles.title",
  },
});
